import { Link } from 'react-router';

const LoggedOut = () => {

    return (
        <>
                <title>TitleOne Admin</title>
            <p>You've been logged out.</p>

            <p><Link to="/">Log Back In</Link></p>
        </>
  );
}

export default LoggedOut;